import translationFallback from '@/utilites/translations/translationFallback';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { OverlayTrigger } from 'react-bootstrap';
import infoIcon from '@/public/images/icons/settings/infoWhite.svg';
import renderTooltip from './renderTooltip';
import styles from './profSeller.module.scss';
export default function ProfSellerBadge({ type }: { type: string }) {
  const { t: tCommon } = useTranslation('common');
  const translation =
    type === 'ask'
      ? 'this_ask_is_from_a_professional_seller'
      : 'this_product_is_sold_by_a_professional_seller';
  const fallback =
    type === 'ask'
      ? 'This ask is from a professional seller'
      : 'This product is sold by a professional seller';
  return (
    <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={(props) =>
        renderTooltip(
          props,
          translationFallback(translation, tCommon(translation), fallback)
        )
      }
    >
      <div className={styles.profSellerTooltip}>
        {translationFallback(
          'prof_seller',
          tCommon('prof_seller'),
          'Prof. Seller'
        )}

        <Image
          style={{ marginLeft: '3px', marginBottom: '4px' }}
          src={infoIcon}
          width={16}
          height={16}
          alt="info"
        />
      </div>
    </OverlayTrigger>
  );
}
